import React, { useState } from 'react';
import Button from '../ui/Button';
import { displayClientName } from '../clientNameUtils';
import { fmtDate } from './LinkStatusList';
import { formatDate } from '../dateUtils';

const money = (v) => `$${(Number(v) || 0).toFixed(2)}`;

// Most recent card-update link for a client, from the page's payment-links rows.
export function latestCardLinkFor(clientId, links) {
  const rows = (links || []).filter(
    (l) => l.linkType === 'card_update' && String(l.clientId) === String(clientId)
  );
  if (!rows.length) return null;
  return rows.reduce((a, b) => (new Date(a.sentAt) >= new Date(b.sentAt) ? a : b));
}

export function linkStatusText(link) {
  if (!link) return 'none sent';
  if (link.status === 'completed') return `used ${fmtDate(link.completedAt)}`;
  if (link.status === 'expired') return `expired (sent ${fmtDate(link.sentAt)})`;
  return `sent ${fmtDate(link.sentAt)}`;
}

// Open debts with per-client card-link status and a one-click send action,
// so the admin never has to cross-reference the Debt Records page.
export default function OpenDebtsPanel({ debts, links, onSendLink }) {
  const [expanded, setExpanded] = useState(true);
  if (!debts || debts.length === 0) return null;

  const th = { textAlign: 'left', borderBottom: '1px solid var(--border-color)', padding: 8, fontSize: 13 };
  const td = { borderBottom: '1px solid var(--surface-muted)', padding: 8, fontSize: 14 };

  return (
    <div style={{ border: '1px solid var(--border-color)', borderRadius: 10, padding: 16, marginBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Open Debts ({debts.length})</h3>
        <Button variant="subtle" onClick={() => setExpanded((o) => !o)}>
          {expanded ? 'Hide' : 'Show'}
        </Button>
      </div>
      {expanded && (
        <div style={{ overflowX: 'auto', marginTop: 12 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Client</th>
                <th style={th}>Session</th>
                <th style={th}>Owed</th>
                <th style={th}>Therapist</th>
                <th style={th}>Card Link</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {debts.map((d) => {
                const owed = (parseFloat(d.billed_amount) || 0) - (parseFloat(d.collected_amount) || 0);
                const link = latestCardLinkFor(d.client_id, links);
                return (
                  <tr key={d.id}>
                    <td style={td}>{displayClientName(d.client_name)}</td>
                    {/* session_date is a pg DATE (arrives as ISO string) — the
                        tz-safe formatter avoids the off-by-one-day shift */}
                    <td style={td}>{formatDate(d.session_date)}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{money(owed)}</td>
                    <td style={td}>{`${d.therapist_first_name || ''} ${d.therapist_last_name || ''}`.trim()}</td>
                    <td style={{ ...td, color: link?.status === 'completed' ? 'var(--success-color)' : 'var(--text-muted)' }}>
                      {linkStatusText(link)}
                    </td>
                    <td style={td}>
                      <Button variant="subtle" onClick={() => onSendLink(d.client_id)}>Send card link</Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
